var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentUploadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1677 6.552H12.734C10.7382 6.552 9.11292 5.008 9.11292 3.112V0.8C9.11292 0.36 8.73398 0 8.27082 0H4.70029C2.10661 0 0.00976562 1.6 0.00976562 4.456V11.544C0.00976562 14.4 2.10661 16 4.70029 16H11.3192C13.9129 16 16.0098 14.4 16.0098 11.544V7.352C16.0098 6.912 15.6308 6.552 15.1677 6.552ZM7.61398 9.224C7.48766 9.344 7.32766 9.4 7.16766 9.4C7.00766 9.4 6.84766 9.344 6.72134 9.224L6.11503 8.648V12C6.11503 12.328 5.82871 12.6 5.48345 12.6C5.13819 12.6 4.85187 12.328 4.85187 12V8.648L4.24556 9.224C4.00134 9.456 3.59713 9.456 3.35292 9.224C3.10871 8.992 3.10871 8.608 3.35292 8.376L5.03713 6.776C5.09608 6.728 5.15503 6.688 5.2224 6.656C5.23924 6.648 5.2645 6.64 5.28134 6.632C5.33187 6.616 5.3824 6.608 5.44134 6.6C5.46661 6.6 5.48345 6.6 5.50871 6.6C5.57608 6.6 5.64345 6.616 5.71082 6.64C5.71924 6.64 5.71924 6.64 5.72766 6.64C5.79503 6.664 5.8624 6.712 5.91292 6.76C5.92134 6.768 5.92977 6.768 5.92977 6.776L7.61398 8.376C7.85819 8.608 7.85819 8.992 7.61398 9.224Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5834 5.4476C13.3834 5.4556 14.4949 5.4556 15.4465 5.4556C15.9265 5.4556 16.1792 4.9196 15.8423 4.5996C14.6297 3.4396 12.4571 1.3516 11.2107 0.167604C10.8655 -0.160396 10.2676 0.0636039 10.2676 0.519604V3.3116C10.2676 4.4796 11.3118 5.4476 12.5834 5.4476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadWhite);
export default __webpack_public_path__ + "static/media/document-upload-white.18b77903f2fb475851e12f0620ba2600.svg";
export { ForwardRef as ReactComponent };